import { enableProdMode } from "@angular/core";
import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "./app/app.module";
import { environment } from "./environments/environment";
import { startNewRelic } from "./app/config/new-relic";

import {
    applyPolyfills,
    defineCustomElements,
} from "@eon-ui/eon-ui-components/loader";

if (environment.production) {
    enableProdMode();
}

startNewRelic();

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.error(err));

// If your app doesn't have to support IE/Edge(legacy), you can skip the applyPolyfills call
applyPolyfills().then(() => {
    defineCustomElements(window); // this registers the E.ON UI components in the browser
});
